export default __webpack_public_path__ + "static/media/Time_Clock.200bdc68.svg";